// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__1EmpB","disabled":"FileBtn_disabled__27Tev","warn":"FileBtn_warn__QqDPH","fade":"FileBtn_fade__3x-0N"};